import TextField from '@/components/skeletons/TextField'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { getEmployeeContains } from '@/modules/Employee/services'
import { randomAvatarSrc } from '@/utils/function'
import { Avatar, Tooltip } from 'vnetwork-ui'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface EmployeesProps {
    employees?: number[]
}
const Employees = ({ employees }: EmployeesProps) => {
    const { data, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.EMPLOYEES],
        queryFn: () =>
            getEmployeeContains({
                employee_ids: employees || [],
            }),
        loadingComponent: <TextField />,
    })

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    const departmentSelected = data?.filter(
        (employee: { label: string; value: number }) =>
            employees?.includes(employee.value)
    )
    return (
        <div className="flex items-center gap-2 flex-wrap">
            {departmentSelected?.map(
                (employee: { label: string; value: number }) => (
                    <Tooltip
                        key={employee.value}
                        title={employee.label}
                        placement="bottom"
                    >
                        <Avatar
                            size="medium"
                            src={randomAvatarSrc(employee.label)}
                            className="cursor-pointer !w-8 !h-8"
                        />
                    </Tooltip>
                )
            )}
        </div>
    )
}

export default Employees
